import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import SalesTab from "./components/SalesTab";
import StoreTab from "./components/StoreTab";
import InventoryTab from "./components/InventoryTab";
import ChannelTab from "./components/ChannelTab";
import SummaryTab from "./components/SummaryTab";
import SimulatorTab from "./components/SimulatorTab";
import ChatBotIcon from "./components/ChatBotIcon";
import ChatFrame from "./chatFrame";
import CommandCenterTab from "./components/CommandCenterTab.tsx";

import HITLTab from "./components/HITLTab";

export default function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [chatInitialMessage, setChatInitialMessage] = useState<string | null>(null);

  // Handler for search send
  const handleSearchSend = (query: string) => {
    setChatInitialMessage(query);
    setChatOpen(true);
  };

  return (
    <BrowserRouter>
      <div className="flex min-h-screen bg-[#F4F5F7]">
        {/* Sidebar: fixed, hidden on mobile */}
        <div className="fixed z-50 top-0 left-0 h-full">
          <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        </div>
        {/* Main area: responsive margin-left for sidebar */}
        <div
          className="flex-1 min-w-0 transition-all"
          style={{
            marginLeft: window.innerWidth >= 768 ? 280 : 0, // 280px for md+, 0 for mobile
          }}
        >
          {/* Navbar: fixed, full width on mobile */}
          <div
            className="fixed z-40 top-0 left-0 right-0"
            style={{
              marginLeft: window.innerWidth >= 768 ? 280 : 0,
            }}
          >
            <Navbar onMenuClick={() => setSidebarOpen(true)} onSearchSend={handleSearchSend} />
          </div>
          {/* Main content: scrollable, with padding-top for navbar height */}
          <main
            className="min-w-0 h-screen overflow-y-auto"
            style={{
              paddingTop: 80, // Navbar height
              background: "#F4F5F7",
            }}
          >
            <Routes>
              <Route path="/" element={<Navigate to="/command-center" replace />} />
              <Route path="/sales" element={<SalesTab />} />
              <Route path="/store" element={<StoreTab />} />
              <Route path="/inventory" element={<InventoryTab />} />
              <Route path="/channel" element={<ChannelTab />} />
              <Route path="/summary" element={<SummaryTab />} />
              <Route path="/simulator" element={<SimulatorTab />} />
              <Route path="/hitl" element={<HITLTab />} />
              <Route path="/command-center" element={<CommandCenterTab />} />
              <Route path="*" element={<Navigate to="/command-center" replace />} />
            </Routes>

            {/* Floating Chatbot */}
            {!chatOpen && <ChatBotIcon onClick={() => setChatOpen(true)} />}
            {chatOpen && (
              <ChatFrame
                onClose={() => {
                  setChatOpen(false);
                  setChatInitialMessage(null);
                }}
                initialMessage={chatInitialMessage}
              />
            )}
          </main>
        </div>
      </div>
    </BrowserRouter>
  );
}